import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { dayjsLocal } from '@trip-ux/common';
interface GenericTableRowProps {
  fields: Object;
  index: number;
  labels?: any;
  status?: string;
  dateFormatCols?: string[];
  linkCol?: Object;
  onPolicyClick?: (policyNumber: string, status: string) => void;
}

const GenericTableRow: FC<GenericTableRowProps> = ({ fields, labels, index, dateFormatCols, linkCol }) => {
  return (
    <tr key={`field-data-${index}`} data-testid="generic-table-row">
      {Object.entries(fields).map(field => {
        const key = field[0];
        const value = field[1];
        const formatedValue =
          dateFormatCols && dateFormatCols.includes(labels[key]) ? dayjsLocal(value).format(labels.dateFormat) : value;
        return linkCol && linkCol.hasOwnProperty(labels[key]) ? (
          <td className="policy-link" aria-label={`${key} ${value} ${index}`} data-label={key} key={key}>
            <Link to={linkCol[labels[key]]}>{formatedValue}</Link>
          </td>
        ) : (
          <td aria-label={`${key} ${value} ${index}`} data-label={key} key={key}>
            {formatedValue}
          </td>
        );
      })}
    </tr>
  );
};

GenericTableRow.displayName = 'GenericTableRow';
export default GenericTableRow;
